import * as React from "react";
import {
  createTheme,
  InputAdornment,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import SearchItem from "../../assets/svgs/searchFilter.svg";
import { useState, CSSProperties } from "react";

interface FormBasicInfoInputFavoriteProps {
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onClick?: () => void;
  onClickFav?: () => void;
  id?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  placeholder?: string;
  title?: string;
  isVisible: boolean;
  disabled?: boolean;
  img2?: string;
  img?: {
    default: string;
    hover: string;
  };
}

const FormBasicInfoInputFavorite = ({
  label,
  value,
  onChange,
  onBlur,
  onClickFav,
  inputProps,
  placeholder,
  img,
  img2,
  disabled,
  isVisible,
  title,
  onClick,
}: FormBasicInfoInputFavoriteProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const customTheme = createTheme({
    palette: {
      primary: {
        main: "#000000",
      },
    },
  });

  const currentIcon = isFocused ? SearchItem : img2;

  const searchItemStyle: CSSProperties = {
    display: "flex",
    width: "20px",
    height: "20px",
    marginTop: "5px",
    cursor: "pointer",
    objectFit: "contain",
  };

  const defaultIconStyle: CSSProperties = {
    display: "flex",
    width: "12px",
    height: "12px",
    marginTop: "5px",
    cursor: "pointer",
    objectFit: "contain",
  };

  return (
    <div>
      <ThemeProvider theme={customTheme}>
        <TextField
          id="filled-basic"
          className=""
          label={label}
          variant="filled"
          value={value}
          onChange={onChange}
          onClick={onClick}
          onBlur={() => {
            setIsFocused(false);
            if (onBlur) onBlur();
          }}
          onFocus={() => setIsFocused(true)}
          inputProps={{ ...inputProps }}
          placeholder={placeholder}
          disabled={disabled}
          sx={{
            "& > :not(style)": { width: "33.2ch" },
            "& .MuiFilledInput-root": {
              borderRadius: "0px",
              backgroundColor: isFocused ? "#C1C7CC" : "#E0E2E5",
              fontSize: "17px",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiInputLabel-root": {
              fontWeight: "500",
              fontSize: "20px",
            },
          }}
          focused
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <>
                  {img && isVisible && (
                    <Tooltip title={title}>
                      <button
                        onClick={onClickFav}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          marginRight: currentIcon ? "8px" : "0",
                          marginTop: "5px",
                          marginLeft: "50px"
                        }}
                      >
                          <img
                            src={isHovered ? img.hover : img.default}
                            alt="Favoritar"
                            width={24}
                            height={24}
                        />

                      </button>
                    </Tooltip>
                  )}

                  {currentIcon && (
                    <img
                      src={currentIcon}
                      alt="icon2"
                      style={
                        currentIcon === SearchItem
                          ? searchItemStyle
                          : defaultIconStyle
                      }
                    />
                  )}
                </>
              </InputAdornment>
            ),
          }}
        />
      </ThemeProvider>
    </div>
  );
};

export default FormBasicInfoInputFavorite;
